export const FILTER_TEMPLATE_NAME_MAX_LENGTH = 30;

export interface FilterTemplate {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  filters: SavedFilterValues;
}

export interface SavedCustomerSelection {
  identity: number;
  name: string;
}

export interface SavedFilterValues {
  view?: number;
  woStatuses?: string[] | null;
  woTechs?: string[] | null;
  woLocations?: string[] | null;
  woSalesPersons?: string[] | null;
  woPriorities?: string[] | null;
  woCustomers?: number[];
  woCustomerDetails?: SavedCustomerSelection[];
  searchString?: string;
  workOrderCreationStartDate?: string | null;
  workOrderCreationEndDate?: string | null;
  workOrderScheduleFromDate?: string | null;
  workOrderScheduleToDate?: string | null;
  workOrderDeliveryStartDate?: string | null;
  workOrderDeliveryEndDate?: string | null;
  workOrderPickupStartDate?: string | null;
  workOrderPickupEndDate?: string | null;
  filterClockedHours?: boolean;
  filterOverClockedHours?: boolean;
  includeFinalized?: boolean;
}

export interface IFilterTemplateRepository {
  getAll(): Promise<FilterTemplate[]>;
  save(template: FilterTemplate): Promise<void>;
  update(template: FilterTemplate): Promise<void>;
  deleteById(id: string): Promise<void>;
}

export interface ExtractSavableFiltersInput {
  filters: Record<string, unknown>;
  view: number;
  selectedCustomers?: SavedCustomerSelection[];
}
